module.exports = __webpack_public_path__ + "media/images/sun-4655ada3c37e81e3e7e0b571b5fb0698.png";